export default class TermAttendanceStatusDomainService {
    static get ATTENDING_ID() {
        return 1;
    }
    static get STOPPED_ATTENDING_ID() {
        return 2;
    }
    static get NEVER_ATTENDED_ID() {
        return 3;
    }
}
